export const bankInterfaceMonitoringMaintenanceRequiredFieldList: string[] = [
    'bankInterfaceMonitoring',
];

export const BankInterfaceMonitoringMaintenanceConstant = {
    CATEGORY: "Interface Monitoring",
    TITLE: "Bank Interface Monitoring",
    MESSAGE_TYPE: "Message Type",
    STATUS: 'Status',
    FROM: 'From',
    TO: 'To',
    DATE_FROM: 'Date (From)',
    DATE_TO: 'Date (To)',
    DATE_RANGE: 'Date Range',
    SEND_RECEIVE_DATE: 'Send/Receive Date',
    BATBCH_NAME: 'Batch Name',
    FILE_NAME: 'File Name',
    MESSAGE: 'Message',
    SEARCH_CRITERIA: 'Search Criteria',

    DRAFT_INVOICE_ID: 'Invoice ID',
    AMOUNT: 'Amount',
    CUSTOMER_ID: 'Customer ID',
    CUSTOMER_NAME: 'Customer Name',
    CUSTOMER_ACC_NUMBER: 'Customer Account Number',
    TRANSACTION_DATE: 'Transaction Date',
    TRANSACTION_NBR: 'Transaction Nbr',
    OP_TYPE: 'Op Type',
    BL_NBR: 'BL Nbr',
    RECORD_ERROR_CODE: 'Record Error Code',
    PERFORMED: 'Performed',
    SAPT_AC_NBR: 'SAPT A/C Nbr',
    KICT_AC_NBR: 'KICT A/C Nbr',
    BRANCH_CODE_NAME: 'Branch Code Name',
    COLLECTION_TYPE: 'Collection Type',
    RECEIVED_BY: 'Received By',

}
